/* eslint-disable */
import React from 'react';

import LinearProgress from '@mui/material/LinearProgress';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';

import {
  CopyBudgetModalStyled,
  ItemsContainer,
  BtnItemsStyled,
  BtnModalStyled,
  LoadingStyled,
  ButtonsContainer,
} from './styles';

export function CopyBudgetModal({
  openModal,
  setOpenModal,
  handleCopyBudgetChange,
  copyBudget,
  handleCopyFromBudget,
  loading,
  constructions,
}) {
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CopyBudgetModalStyled>
        <Typography variant="h2">Copiar orçamento</Typography>
        <ItemsContainer>
          {loading ? (
            <LoadingStyled>
              <LinearProgress style={{ width: '80%' }} />
            </LoadingStyled>
          ) : (
            <List>
              <li>
                <input
                  type="radio"
                  value={0}
                  name="copy-budget"
                  id="copy-budget-0"
                  onChange={handleCopyBudgetChange}
                />
                <label htmlFor="copy-budget-0">TEMPLATE RESIDENCIAL 01</label>
              </li>
              {constructions.map((option) => (
                <li key={option.id}>
                  <input
                    type="radio"
                    value={option.id}
                    name="copy-budget"
                    id={`copy-budget-${option.id}`}
                    onChange={handleCopyBudgetChange}
                  />
                  <label htmlFor={`copy-budget-${option.id}`}>
                    {option.name}
                  </label>
                </li>
              ))}
            </List>
          )}
        </ItemsContainer>
        <hr />
        <ButtonsContainer>
          <BtnModalStyled
            color="primary"
            variant="outlined"
            onClick={() => handleCopyFromBudget(true)}
            disabled={copyBudget === null || copyBudget === '0'}
          >
            Itens e valores
          </BtnModalStyled>
          <BtnItemsStyled
            color="secondary"
            variant="contained"
            onClick={() => handleCopyFromBudget(false)}
            disabled={copyBudget === null}
          >
            Itens
          </BtnItemsStyled>
        </ButtonsContainer>
      </CopyBudgetModalStyled>
    </Modal>
  );
}
